import { render, staticRenderFns } from "./Titles.vue?vue&type=template&id=d204c070&scoped=true&"
import script from "./Titles.vue?vue&type=script&lang=ts&"
export * from "./Titles.vue?vue&type=script&lang=ts&"
import style0 from "./Titles.vue?vue&type=style&index=0&id=d204c070&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d204c070",
  null
  
)

export default component.exports